<app-banner></app-banner>
<app-explore-vehicle-range></app-explore-vehicle-range>
<ng-container *ngIf="loading">
  <app-brows-by-application></app-brows-by-application>
  <app-brands-you-can-trust></app-brands-you-can-trust>
  <section class="buy-can-trust-sec bg-cryan pt-3 pb-3 buy-your-dream">
    <div class="container">

      <div class="row" *ngFor="let item of highlightmasterData">
        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 box box1 peopleImg">
          <div class="">
            <div class="d-flex highlightText">
              <img alt="people" [src]="environment1+'assets/images/people.png'" style="height: 50px;"/>
              </div>
              </div>
              </div>
       <div class="col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10 box box1 d-flex highlightTab">
        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box box1">
          <div class="content">
            <div class="d-flex highlightText">
              <div class="forhighlightnumber">
                {{item?.total_users | number}}
               </div>
          </div>
            <h3 class="cv-text-dark fw-semibold fs-4 font-size-16" style="text-align-last: center;
            padding: 0px;">Total Users</h3>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box box1">
          <div class="content">
            <div class="d-flex highlightText">
              <div class="forhighlightnumber">
                {{item?.total_events | number}}
               </div>
            </div>
            <h3 class="cv-text-dark fw-semibold fs-4 font-size-16" style="text-align-last: center;
            padding: 0px;">Total Events</h3>
          </div>

        </div>
        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box box1">
          <div class="content">
            <div class="d-flex highlightText">
              <div class="forhighlightnumber">
                {{item?.total_views | number}}
               </div>
            </div>
            <h3 class="cv-text-dark fw-semibold fs-4 font-size-16" style="text-align-last: center;
            padding: 0px;">Total Views </h3>
               </div>

        </div>
      </div>
      </div>
    </div>
  </section>
  <app-popular-vehicle></app-popular-vehicle>
  <div class="brand-videos pt-5 pb-5">
    <div class="container">
      <h1 class="page-sub-title cv-text-dark mb-4">Brand Videos</h1>
      <div class="row">
        <ng-container *ngIf="promotionalVideos?.length == 0 && !productLoaded;else productTemplate">
          <ng-container *ngFor="let item of skeletonService.generateFake(1);let i = index;">
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 ps-xl-0">
              <div class="ratio ratio-16x9">
                <ngx-skeleton></ngx-skeleton>
              </div>
            </div>
          </ng-container>
          <ng-container>
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 position-relative overflow-hidden">
              <div class="scroll d-lg-grid gap-3">
                <ng-container *ngFor="let item of skeletonService.generateFake(5);let i = index;">
                  <div class="grid-item">
                    <div class="ratio ratio-16x9">
                      <ngx-skeleton height="150px"></ngx-skeleton>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #productTemplate>
          <ng-container *ngFor="let item of videoData;let id = index">
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9" *ngIf="id == 0">
              <div class="ratio ratio-16x9">
                <ngx-lite-youtube [videoId]="getURL(item?.path)"></ngx-lite-youtube>
              </div>
            </div>
          </ng-container>
          <ng-container>
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 position-relative overflow-hidden">
              <div class="scroll d-lg-grid gap-3" #brandVideoDiv id="brandVideoDiv" (scroll)="onScrollDiv($event)">
                <ng-container *ngFor="let item of videoData;let id = index">
                  <div class="grid-item" *ngIf="id !== 0">
                    <div class="ratio ratio-16x9">
                      <ngx-lite-youtube [videoId]="getURL(item?.path)"></ngx-lite-youtube>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
   <section class="promotional-videos pt-5 pb-5 attract-vechicle position-relative" *ngIf="offersData?.length > 0">
    <img [src]='environment1 + "assets/images/Square-T-blue.png"' class="t-image" alt="T">
    <div class="horizontal-line"></div>
    <div class="bottom-vertical-line"></div>
    <div class="container">
      <div class="content-heading row mb-4 align-items-center">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 d-flex">
          <h1 class="page-sub-title cv-text-dark">Avail attractive vehicle loan options on our product</h1>
          <a href=""  class="ms-auto text-nowrap view-more d-inline-flex alignin-items-center " style="margin-top: 12px;"
            [routerLink]="'/offers'">View All <img [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="right_Arr" loading="lazy"></a>
        </div>
      </div>
      <div class="row">
        <div class="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-xxl-11" style="margin-left: 84px;">
          <div class="carousel-sec">
            <ng-container *ngIf="offersData?.length == 0 || !OfferLoaded;else offerTemplate">
              <owl-carousel-o [options]="customOptionsAttractVechicle">
                <ng-template carouselSlide *ngFor="let item of skeletonService.generateFake(4);let i = index;">
                  <div class="item">
                    <div class="c-box-row">
                      <div class="c-box">
                        <div class="box">
                          <div class="box-top-content">
                            <div class="ellipse ellipse-1"></div>
                            <div class="ellipse ellipse-2"></div>
                            <ngx-skeleton height="120px"></ngx-skeleton>
                          </div>
                          <div class="box-bottom-content">
                            <div class="ellipse ellipse-5"></div>
                            <div class="ellipse ellipse-6"></div>
                            <h5> <ngx-skeleton height="35px"></ngx-skeleton></h5>
                            <h6> <ngx-skeleton height="20px"></ngx-skeleton></h6>
                            <p> <ngx-skeleton height="15px"></ngx-skeleton></p>
                            <a><ngx-skeleton height="40px" width="100px"></ngx-skeleton></a>
                            <div class="ellipse ellipse-3"></div>
                            <div class="ellipse ellipse-4"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </owl-carousel-o>
            </ng-container>

            <ng-template #offerTemplate>
              <owl-carousel-o [options]="customOptionsAttractVechicle">
                <ng-container>
                  <ng-template carouselSlide *ngFor="let item of offersData">
                    <div class="item">
                      <div class="c-box-row">
                        <div class="c-box">
                          <div class="box">
                            <div class="box-top-content" style="height: 153px;">
                              <div class="ellipse ellipse-1"></div>
                              <div class="ellipse ellipse-2"></div>
                              <img class="img-fluid" style="height: 62px !important;" alt="{{item?.financierDetails?.crmFinancierName}}"
                                src={{setFinancierImgUrl(item?.financierId)}} loading="lazy">

                            </div>
                            <div class="box-bottom-content">
                              <div class="ellipse ellipse-5"></div>
                              <div class="ellipse ellipse-6"></div>
                              <h5>{{ item.financierSchemeName }}</h5>
                              <!-- <h6>EMI starting at {{ item.emiPerLac | currency:'INR':'symbol':'4.0-0' }}* for a tenure
                                of {{ item.tenure }} Months</h6> -->
                              <p>{{ item.description }}</p>
                              <a (click)="navigateToOfferDetail(item?.financierSchemeId)" class="cursor" >
                                <img class="plus" [src]="environment1 + 'images/new-images/plus.svg'" alt="plus"  loading="lazy" >
                                More Details</a>
                              <div class="ellipse ellipse-3"></div>
                              <div class="ellipse ellipse-4"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container">
      <div class="plp-configure-wrapper pt-5 pb-5">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h1>Not sure which CV to buy?</h1>
            <p class="mb-4">Let us help you find the perfect CV for your application</p>
            <button class="btn btn-primary btn-grad-primary ps-5 pe-5 btn-height button-txt-desktop"
              (click)="callConfigurator()"
              data-toggle="tooltip" data-placement="top" title="Click here to Build your own vehicle">Build your own
              vehicle</button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-customer-stories></app-customer-stories>
  <app-dealer-stories></app-dealer-stories>
  <app-our-other-services></app-our-other-services>
  <app-tata-mitra></app-tata-mitra>
  <app-find-dealers *ngIf="!isMobile && !dealerCode "></app-find-dealers>


</ng-container>
